module.exports = __webpack_public_path__ + "static/media/calendar.9f600671.svg";